import './style.scss';

export function about_us_block() {
  const block = document.querySelector('.about_us_block');
  if (!block) return;
  
}
